var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconeye = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 38,
    viewBox: "0 0 53 38",
    fill: "#f3123c",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24.5,26C13.133,26,4.166,20.012.323,14.077a1.961,1.961,0,0,1,0-2.155C4.166,5.988,13.133,0,24.5,0S44.833,5.988,48.679,11.923a1.969,1.969,0,0,1,0,2.155C44.833,20.012,35.865,26,24.5,26Zm0-21.667C15.392,4.333,8.491,9,5.348,13c3.141,4,10.041,8.668,19.152,8.668S40.512,17,43.654,13C40.512,9,33.611,4.333,24.5,4.333Zm0,15.167c-4.053,0-7.35-2.917-7.35-6.5s3.3-6.5,7.35-6.5a2.324,2.324,0,0,1,2.45,2.167,2.324,2.324,0,0,1-2.45,2.167A2.324,2.324,0,0,0,22.05,13a2.324,2.324,0,0,0,2.45,2.167A2.324,2.324,0,0,0,26.95,13a2.47,2.47,0,0,1,4.9,0C31.852,16.584,28.554,19.5,24.5,19.5Z",
    transform: "translate(2 6)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconeye, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/iconeye.85f34fe3.svg";
export { ForwardRef as ReactComponent };